import { render, staticRenderFns } from "./EditTos.vue?vue&type=template&id=30ce74a1"
import script from "./EditTos.vue?vue&type=script&lang=js"
export * from "./EditTos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports